export default "__VITE_ASSET__CLd1y9Am__"